import React from 'react';
import './TopLinks.css';
import logoFb from '../assets/images/fb-logo.png'; // Use this image as a placeholder for all logos
import logoIg from '../assets/images/ig-logo.png'; // Use this image as a placeholder for all logos

const LIRMI_LABEL = 'NUEVO 2026: PAGAR MENSUALIDAD ONLINE (LIRMI)';

const TopLinks = () => {
  return (
    <div className='top-links-container'>
      <div className='social-icons'>
        <a href='https://web.facebook.com/colegiofenixoficial' target='_blank' rel='noopener noreferrer'>
          <img src={logoFb} alt='Facebook' className='icon' />
        </a>
        <a href='https://www.instagram.com/colegiofenixchile/' target='_blank' rel='noopener noreferrer'>
          <img src={logoIg} alt='Instagram' className='icon' />
        </a>
        {/* <a
          href='https://familia.lirmi.com/latam/login'
          className='link link-lirmi'
          target='_blank'
          rel='noopener noreferrer'
        >
          {LIRMI_LABEL.split('').map((char, index) => (
            <span
              key={index}
              className='link-lirmi-letter'
              style={{ animationDelay: `${index * 0.07}s` }}
            >
              {char === ' ' ? '\u00A0' : char}
            </span>
          ))}
        </a> */}
      </div>
    </div>
  );
};

export default TopLinks;
